import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import {
  ButtonChatContactExample,
  ButtonRoundedExample,
  FrostedPillExample,
} from '../../components/UISystem/Buttons';
import IconBack from '../../components/UISystem/Icons/IconBack';

/**
 * ButtonsScreen Component
 *
 * Displays all Button components in the UI System
 */
const ButtonsScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header */}
      <div style={UI_SCREEN_STYLES.header}>
        <div style={UI_SCREEN_STYLES.backButton}>
          <IconBack onClick={onBack} />
        </div>
        <div style={UI_SCREEN_STYLES.title}>Buttons</div>
      </div>

      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        <FrostedPillExample />
        <ButtonRoundedExample />
        <ButtonChatContactExample />
      </div>
    </div>
  );
};

export default ButtonsScreen;
